import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MaterialIcon, {
  type MaterialIconName,
} from 'components/shared/MaterialIcon';

const StyledGrid = styled(Grid)(() => {
  return {
    flexGrow: 1,
  };
});

const InputContainer = styled(Grid)(() => {
  return {
    flexGrow: 1,
  };
});

const typeToIconMap: Record<string, MaterialIconName | ''> = {
  text: '',
  email: 'alternate_email',
  password: 'lock',
};

const FancyInput = (props) => {
  const { type, icon, ...other } = props;
  const iconName = (icon || typeToIconMap[type]) as MaterialIconName | '';
  return (
    <StyledGrid
      container
      spacing={1}
      alignItems="flex-end"
      sx={{ width: '100%' }}
    >
      {iconName ? (
        <Grid>
          <MaterialIcon name={iconName} color="action" />
        </Grid>
      ) : null}
      <InputContainer size="grow">
        <TextField fullWidth type={type} {...other} />
      </InputContainer>
    </StyledGrid>
  );
};

FancyInput.propTypes = {
  type: PropTypes.oneOf(['text', 'email', 'password']).isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

export default FancyInput;
